<template>
  <div class="item-list">
    <div v-for="item in items" :key="item.key">
      <item :item="item"></item>
    </div>
  </div>
</template>

<script>
  import Item from '@/components/Item'
  import infiniteScroll from 'vue-infinite-scroll'

  export default {
    name: 'item-list',
    data () {
      return {
        position: 20,
        busy: false
      }
    },
    computed: {
      items () {
        return this.$store.getters['destiny/items'].slice(0, this.position)
      }
    },
    methods: {
      loadMore () {
        this.busy = false
        this.position += 10
      },
      onScroll (e) {
        if (this.oldOnScroll) {
          this.oldOnScroll(e)
        }
        if ((e.pageY || (document.scrollingElement || {}).scrollTop) + window.innerHeight * 3 > this.$el.offsetTop + this.$el.offsetHeight) {
          this.position += 10
        }
      }
    },
    components: {Item},
    directives: {infiniteScroll},
    created () {
      this.storeWatcher = this.$store.watch(
        (state) => {
          return this.$store.getters['destiny/items']
        },
        (newVal) => {
          this.position = 20
        }
      )
    },
    mounted () {
      this.oldOnScroll = document.body.onscroll
      document.body.onscroll = this.onScroll
    },
    beforeDestroy () {
      document.body.onscroll = this.oldOnScroll
      this.storeWatcher()
    }
  }
</script>

<style lang="scss" scoped>
  .button {
    position: fixed;
    background-color: #1f262e;
    z-index: 3;
    border-radius: 100%;
    box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.3);
    top: 2rem;
    right: 2rem;
    padding: 1rem;
    transition: 0.2s;
    &:hover {
      cursor: pointer;
      background-color: #343f4c;
      box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.3)
    }
  }
</style>



// WEBPACK FOOTER //
// ItemList.vue?e5125d72